import Hero from "../components/Hero";
import Categories from "../components/Categories";
import ProductCard from "../components/ProductCard";
import { useProducts } from "../context/ProductContext";
import { Link } from "react-router-dom";
import { FiTruck, FiRefreshCw, FiShield, FiPhone } from "react-icons/fi";
import "./Home.css";

export default function Home() {
  const { products, loading } = useProducts();
  const newArrivals = products.filter(p => p.badge === "New");
  const bestsellers = products.filter(p => p.badge === "Hot" || p.rating >= 4.7).slice(0, 4);
  const saleItems   = products.filter(p => p.originalPrice).slice(0, 4);
  return (
    <main className="home">
      {/* Circle Categories */}
      <Categories />

      {/* Hero Carousel */}
      <Hero />

      {/* Trust Bar */}
      <div className="trust-bar">
        <div className="trust-item"><FiTruck /><span>Free Delivery over Rs. 2000</span></div>
        <div className="trust-item"><FiRefreshCw /><span>Easy 30-Day Returns</span></div>
        <div className="trust-item"><FiShield /><span>100% Secure Payment</span></div>
        <div className="trust-item"><FiPhone /><span>24/7 Customer Support</span></div>
      </div>

      {/* New Arrivals */}
      <section className="home-section">
        <div className="section-head">
          <div>
            <span className="section-tag">Just In</span>
            <h2>New Arrivals</h2>
          </div>
          <Link to="/shop?category=new" className="see-all-link">View All →</Link>
        </div>
        <div className="products-grid">
          {newArrivals.map(p => <ProductCard key={p.id} product={p} />)}
        </div>
      </section>

      {/* Bestsellers */}
      <section className="home-section">
        <div className="section-head">
          <div>
            <span className="section-tag">Top Picks</span>
            <h2>Bestsellers</h2>
          </div>
          <Link to="/shop" className="see-all-link">View All →</Link>
        </div>
        <div className="products-grid">
          {bestsellers.map(p => <ProductCard key={p.id} product={p} />)}
        </div>
      </section>

      {/* Lifestyle Banner — Stitched */}
      <div className="lifestyle-banner-center">
        <div className="lifestyle-img">
          <img src="https://images.unsplash.com/photo-1583496661160-fb5886a0aaaa?w=1400&q=85" alt="Stitched Collection" />
        </div>
        <div className="lifestyle-overlay" />
        <div className="lifestyle-center-content">
          <span className="section-tag">Ready to Wear</span>
          <h2>Stitched Suits for Every Occasion</h2>
          <p>From casual everyday wear to festive stitched suits — crafted for the woman who values style and convenience.</p>
          <Link to="/shop?category=stitched" className="btn-gold">Shop Stitched</Link>
        </div>
      </div>

      {/* Sale Section */}
      <section className="home-section sale-section">
        <div className="sale-header-block">
          <div>
            <span className="section-tag sale-tag">Limited Time</span>
            <h2>On Sale Now</h2>
            <p>Up to 50% off on selected styles</p>
          </div>
          <Link to="/shop?category=sale" className="see-all-link">Shop All Sale →</Link>
        </div>
        <div className="products-grid">
          {saleItems.map(p => <ProductCard key={p.id} product={p} />)}
        </div>
      </section>

      {/* Testimonials */}
      <section className="home-section">
        <div className="section-head centered">
          <span className="section-tag">Reviews</span>
          <h2>What Our Customers Say</h2>
        </div>
        <div className="testimonials-grid">
          {[
            { name: "Ayesha R.", location: "Lahore", text: "Absolutely love the lawn quality! The fabric is so soft and the embroidery is perfect. Will definitely order again.", rating: 5, avatar: "A" },
            { name: "Sana M.", location: "Karachi", text: "Delivery was super fast and the packaging was beautiful. The stitched suit fits exactly as shown in the pictures.", rating: 5, avatar: "S" },
            { name: "Fatima K.", location: "Islamabad", text: "Best online clothing store in Pakistan. Great variety, affordable prices and amazing customer service.", rating: 4, avatar: "F" },
          ].map((t, i) => (
            <div key={i} className="testimonial-card">
              <div className="t-stars">{"★".repeat(t.rating)}{"☆".repeat(5 - t.rating)}</div>
              <p>"{t.text}"</p>
              <div className="t-author">
                <div className="t-avatar">{t.avatar}</div>
                <div>
                  <strong>{t.name}</strong>
                  <span>{t.location}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Newsletter */}
      <div className="newsletter-section">
        <div className="newsletter-content">
          <span className="section-tag">Stay Updated</span>
          <h2>Subscribe & Get 10% Off</h2>
          <p>Join our newsletter for exclusive deals, new arrivals and style tips.</p>
          <form className="newsletter-form" onSubmit={e => e.preventDefault()}>
            <input type="email" placeholder="Enter your email address" />
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </div>
    </main>
  );
}
